import {DeleteRequestFile} from 'domain/usecases';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteRequestDeleteFile implements DeleteRequestFile {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient,
	) {}

	async delete() {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'delete',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
